import queryGQL from "@/Apollo/query/pay-per-listing/dynamicListingFeePackages.graphql";
import {
  DynamicListingFeePackagesQuery,
  DynamicListingFeePackagesQueryVariables,
} from "@/Apollo/schema";
import { QueryHookOptions, useQuery } from "@apollo/client";

export const useDynamicListingFeePackages = (
  options?: QueryHookOptions<
    DynamicListingFeePackagesQuery,
    DynamicListingFeePackagesQueryVariables
  >
) => {
  return useQuery(queryGQL, options);
};
